import React from 'react'
import ConnectedApp from '@driftt/traffic-control'
import ReactDOM from 'react-dom'
import { LoadStyles } from '@driftt/tide'
import createHistory from 'history/createBrowserHistory'

import App from 'components/App'
import { rootReducer, rootEpic } from 'modules'
import config from 'config'

import './index.css'

const mainReducer = {
  key: "__KNOWLEDGEBASE",
  reducer: rootReducer
}

const history = createHistory()

LoadStyles()

ReactDOM.render(
  <ConnectedApp
    reducers={[ mainReducer ]}
    epics={[ rootEpic ]}
    render={() => <App history={history}/>}
    authClientId={config.AUTH_CLIENT_ID}
  />,
  document.getElementById('root')
)
